import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMainContext } from "../../../Context";

export const useOrderDetails = ({ api, key }) => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { post } = useMainContext();
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    setLoading(true);
    const { data } = await post(api?.route, { [key]: id });
    setData(data);
    setLoading(false);
  };

  return {
    loading,
    data,
    id,
  };
};
